const oktaAuthConfig = {
    // Note: If your app is configured to use the Implicit Flow
    // instead of the Authorization Code with Proof of Code Key Exchange (PKCE)
    // you will need to add `pkce: false`
    issuer: 'https://dev-5540852.okta.com/oauth2/default',
    clientId: '0oa39bz231HdHYuXN5d6',
    redirectUri: window.location.origin + '/login-redirect-okta',
    scope: ['openid', 'profile', 'email'],
    pkce: true
};

const oktaSignInConfig = {
    baseUrl: 'https://dev-5540852.okta.com',
    clientId: '0oa39bz231HdHYuXN5d6',
    redirectUri: window.location.origin + '/login-redirect-okta',
    scope: ['openid', 'profile', 'email'],
    authParams: {
        issuer: "https://dev-5540852.okta.com/oauth2/default",
        pkce: true
    }
};

export { oktaAuthConfig, oktaSignInConfig };